import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";
import moment from "moment";

const FundTransferView = () => {
  const { id } = useParams();
  const [transfer, setTransfer] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Http.get(`/accounts/fund-transfers/${id}`)
      .then((res) => {
        setTransfer(res.data.data);
      })
      .catch((error) => {
        console.error("Fetch error:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id]);

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Fund Transfer Details</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">Transfer Information</h6>
            
            {loading ? (
              <div className="text-center">
                <ProgressSpinner />
              </div>
            ) : (
              <div className="card-body">
                {/* General Information Table - Vertical */}
                <h5 className="mb-3">General Information</h5>
                <table className="table table-bordered mb-4">
                  <tbody>
                    <tr>
                      <th width="30%">Date</th>
                      <td>{transfer.date ? moment(transfer.date).format("DD/MM/YYYY") : "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Transfer Number</th>
                      <td>{transfer.transfer_number || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <td>{transfer.status || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Amount</th>
                      <td>{transfer.amount ? `${parseFloat(transfer.amount).toFixed(2)}` : "0.00"}</td>
                    </tr>
                    <tr>
                      <th>Description</th>
                      <td>{transfer.description || "N/A"}</td>
                    </tr>
                  </tbody>
                </table>
                
                <div className="row">
                  {/* From Account Table - Horizontal */}
                  <div className="col-md-6">
                    <h5 className="mb-3">From Account</h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Account Name</th>
                          <th>Account Type</th>
                          <th>Branch</th>
                          <th>Account Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{transfer.from_bank?.name || "N/A"}</td>
                          <td>{transfer.from_bank?.type || "N/A"}</td>
                          <td>{transfer.from_bank?.branch || "N/A"}</td>
                          <td>{transfer.from_bank?.account_number || "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  
                  {/* To Account Table - Horizontal */}
                  <div className="col-md-6">
                    <h5 className="mb-3">To Account</h5>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Account Name</th>
                          <th>Account Type</th>
                          <th>Branch</th>
                          <th>Account Number</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{transfer.to_bank?.name || "N/A"}</td>
                          <td>{transfer.to_bank?.type || "N/A"}</td>
                          <td>{transfer.to_bank?.branch || "N/A"}</td>
                          <td>{transfer.to_bank?.account_number || "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                
                {/* Audit Information */}
                {/* <h5 className="mb-3 mt-4">Audit Information</h5>
                <table className="table table-bordered">
                  <tbody>
                    <tr>
                      <th width="30%">Created By</th>
                      <td>{transfer.created_by?.name || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Created At</th>
                      <td>
                        {transfer.created_at
                          ? moment(transfer.created_at).format("DD/MM/YYYY hh:mm A")
                          : "N/A"}
                      </td>
                    </tr>
                    <tr>
                      <th>Updated At</th>
                      <td>
                        {transfer.updated_at
                          ? moment(transfer.updated_at).format("DD/MM/YYYY hh:mm A")
                          : "N/A"}
                      </td>
                    </tr>
                  </tbody>
                </table> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FundTransferView;